export const CLEAN_AUTH_ERROR = 'CLEAN_AUTH_ERROR'

export const cleanAuthErrors = () => ({
  type: CLEAN_AUTH_ERROR,
})
